import { API_DOMEN } from '../constants/constants'

/** url файла абсолютный — файл в S3/внешнем хранилище, а не `/uploads/...` на бэкенде. */
export function isAbsoluteUploadUrl(url: string): boolean {
    return /^https?:\/\//i.test(url)
}

/**
 * Адрес для открытия/скачивания загруженного файла: абсолютный url (S3) — как есть,
 * относительный (`/uploads/...`, локальное хранилище Strapi) — от домена API.
 */
export default function resolveUploadUrl(url: string): string {
    if (isAbsoluteUploadUrl(url)) {
        return url
    }

    return `${API_DOMEN}${url.startsWith('/') ? url : `/${url}`}`
}
